import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp, faThumbsDown, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import {
  faThumbsUp as faThumbsUpOutline,
  faThumbsDown as faThumbsDownOutline,
} from "@fortawesome/free-regular-svg-icons";
import { Box, Typography, TextField } from "@mui/material";

const ChatbotResponse = ({ response, chatId, onFeedbackSubmit, isIntroduction }) => {
  const [feedback, setFeedback] = useState({
    rating: 0,
    comment: "",
  });
  const [showFeedbackOptions, setShowFeedbackOptions] = useState(true);
  const [showFeedbackField, setShowFeedbackField] = useState(false);
  const [showThumbsUp, setShowThumbsUp] = useState(false);
  const [showThumbsDown, setShowThumbsDown] = useState(false);

  const handleThumbsUp = () => {
    setFeedback({ ...feedback, rating: 1 });
    setShowFeedbackOptions(false);
    setShowFeedbackField(false);
    setShowThumbsUp(true);
    setShowThumbsDown(false);
    onFeedbackSubmit(chatId, response, { rating: 1, comment: "" });
  };

  const handleThumbsDown = () => {
    setFeedback({ ...feedback, rating: -1 });
    setShowFeedbackOptions(false);
    setShowFeedbackField(true);
    setShowThumbsUp(false);
    setShowThumbsDown(true);
  };

  const handleFeedbackChange = (e) => {
    setFeedback({ ...feedback, comment: e.target.value });
  };

  const handleSubmitFeedback = () => {
    setShowFeedbackOptions(false);
    setShowFeedbackField(false);
    setShowThumbsUp(false);
    setShowThumbsDown(true);
    onFeedbackSubmit(chatId, response, feedback);
  };

  const enterPress = (e) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault();
      handleSubmitFeedback();
    }
  };

  // Don't show feedback buttons for introduction messages
  if (isIntroduction) {
    return null;
  }

  const themeMode = window.__ASKBLAZE_THEME_MODE__ === "dark" ? "dark" : "light";

  return (
    // <div className="chatbot-response">
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
      {/* TODO fix the font here */}
      <Typography variant="caption" color={themeMode === "dark" ? "#bcbcbc" : "#767676"}>
        Did I help?
      </Typography>
      {showThumbsUp && (
        <div className="feedback-buttons" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span className={"outline-button"}>
            <FontAwesomeIcon icon={faThumbsUp} style={{ color: themeMode === "dark" ? "#bcbcbc" : "#767676" }} />
          </span>
          <Typography variant="caption" color={themeMode === "dark" ? "#bcbcbc" : "#767676"}>
            Thanks for your feedback!
          </Typography>
        </div>
      )}
      {showThumbsDown && (
        <div className="feedback-buttons" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span className={"outline-button"}>
            <FontAwesomeIcon icon={faThumbsDown} style={{ color: themeMode === "dark" ? "#bcbcbc" : "#767676" }} />
          </span>
          <Typography variant="caption" color={themeMode === "dark" ? "#bcbcbc" : "#767676"}>
            Thanks for your feedback!
          </Typography>
        </div>
      )}
      {showFeedbackOptions && (
        <div className="feedback-buttons" style={{ display: "flex", gap: "8px" }}>
          <span
            className={"outline-button"}
            onClick={handleThumbsUp}
            style={{ color: themeMode === "dark" ? "#bcbcbc" : "#767676" }}
          >
            <FontAwesomeIcon icon={faThumbsUpOutline} />
          </span>
          <span
            className={"outline-button"}
            onClick={handleThumbsDown}
            style={{ color: themeMode === "dark" ? "#bcbcbc" : "#767676" }}
          >
            <FontAwesomeIcon icon={faThumbsDownOutline} />
          </span>
        </div>
      )}
      {showFeedbackField && (
        <div
          className={"feedback-container"}
          style={{ flex: 1, display: "flex", gap: "12px", alignItems: "center", marginTop: "8px" }}
        >
          {/* Visually hidden label for accessibility */}
          <label htmlFor={`feedback-input-${chatId}`} style={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            padding: 0,
            margin: '-1px',
            overflow: 'hidden',
            clip: 'rect(0,0,0,0)',
            border: 0,
          }}>
            Feedback input
          </label>
          <TextField
            id={`feedback-input-${chatId}`}
            placeholder="Optional: Provide feedback"
            value={feedback.comment}
            onChange={handleFeedbackChange}
            onKeyDown={enterPress}
            multiline
            maxRows={5}
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                fontSize: "0.75rem",
              },
            }}
          />
          <span className={"outline-button"} onClick={handleSubmitFeedback}>
            <FontAwesomeIcon style={{ margin: 1 }} icon={faPaperPlane} />
          </span>
        </div>
      )}
    </Box>
  );
};

export default ChatbotResponse;
